interface NeoTitleProps {
  message: string;
}

export const NeoTitle: React.FC<NeoTitleProps> = ({message}) => {
  return <h4 className="text-4xl font-bold">{message}</h4>;
};
